import React, { useEffect, useState } from 'react';
import PricingCard from './components/pricingCard';

const ChooseCampaignType = () => {
	const bannersData = {
		salesIncentive: {
			banner1: {
				title: 'Free Brand Account',
				value: '',
				includes: [
					'Brand Profile on ENDVR Network',
					'Reach Your Entire Retail Network',
					'Free Brand Video',
					'Free Brand Newsfeed',
					'Unlimited Sales Reps',
				],
			},
			banner2: {
				title: 'Pay-As-You-Go',
				value: '4%',
				includes: [
					'Incentives To Your Entire Retail Network',
					'Easy Campaign Builder',
					'Campaign Scheduling',
					'Store Targeting',
					'Brand Admin Seat',
					'AI Receipt Review',
				],
			},
			banner3: {
				title: 'Annual Subscription',
				value: '3%',
				includes: [
					'Discounted Rates',
					'Unlimited Brand Admin Seats',
					'Reporting + Data & Insights',
					'Campaign Optimization Specialist',
				],
				button: 'Talk to Sales',
			},
		},
		digitalEducation: {
			banner1: {
				title: 'Free Brand Account',
				value: '',
				includes: [
					'Brand Profile on ENDVR Network',
					'Reach Your Entire Retail Network',
					'Free Brand Video',
					'Free Brand Newsfeed',
					'Unlimited Sales Reps',
				],
			},
			banner2: {
				title: 'Pay-As-You-Go',
				value: '$10',
				includes: [
					'Education To Your Entire Retail Network',
					'Easy Campaign Builder',
					'Campaign Scheduling',
					'Store Targeting',
					'Brand Admin Seat',
					'AI Receipt Review',
				],
			},
			banner3: {
				title: 'Annual Subscription',
				value: '$4',
				includes: [
					'Discounted Rates',
					'Unlimited Brand Admin Seats',
					'Reporting + Data & Insights',
					'Campaign Optimization Specialist',
				],
			},
		},
		frontlineInsights: {
			banner1: {
				title: 'Free Brand Account',
				value: '',
				includes: [
					'Brand Profile on ENDVR Network',
					'Reach Your Entire Retail Network',
					'Free Brand Video',
					'Free Brand Newsfeed',
					'Unlimited Sales Reps',
				],
			},
			banner2: {
				title: 'Pay-As-You-Go',
				value: '$6',
				includes: [
					'Insights From Your Entire Retail Network',
					'Easy Campaign Builder',
					'Campaign Scheduling',
					'Store Targeting',
					'Brand Admin Seat',
					'AI Receipt Review',
				],
			},
			banner3: {
				title: 'Annual Subscription',
				value: '$2',
				includes: [
					'Discounted Rates',
					'Unlimited Brand Admin Seats',
					'Reporting + Data & Insights',
					'Campaign Optimization Specialist',
				],
			},
		},
	};

	const [currentGroup, setCurrentGroup] = useState('salesIncentive');

	useEffect(() => {
		function sendHeight() {
			const container = document.getElementById('iframe-content-container');
			const totalHeight = container ? container.offsetHeight + 96 : document.body.offsetHeight;

			if (window.lastSentHeight !== totalHeight) {
				window.lastSentHeight = totalHeight;
				window.parent.postMessage({ iframeHeight: totalHeight }, '*');
			}
		}

		sendHeight();
		const heightInterval = setInterval(sendHeight, 1000);
		window.addEventListener('load', sendHeight);
		window.addEventListener('resize', sendHeight);
		window.addEventListener('orientationchange', sendHeight);
		const observer = new MutationObserver(sendHeight);
		observer.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			characterData: true,
		});

		setTimeout(sendHeight, 100);

		return () => {
			clearInterval(heightInterval);
			window.removeEventListener('load', sendHeight);
			window.removeEventListener('resize', sendHeight);
			window.removeEventListener('orientationchange', sendHeight);
			observer.disconnect();
		};
	}, [currentGroup]);

	return (
		<div className="min-h-screen py-12 px-4 font-['Roboto',sans-serif]">
			<div id="iframe-content-container" className="max-w-7xl mx-auto">
				<h1 className="text-4xl font-bold text-center text-[#343640] mb-8">
					Choose Your Campaign Type
				</h1>

				<div className="flex justify-center mb-10">
					<div className="w-full sm:w-auto sm:rounded-full sm:overflow-hidden">
						<div className="flex flex-col sm:flex-row">
							{Object.keys(bannersData).map((group, index, array) => (
								<button
									key={group}
									onClick={() => setCurrentGroup(group)}
									className={`flex items-center justify-center px-8 sm:px-12 py-5 rounded-lg
									${index > 0 ? 'mt-2 sm:mt-0' : ''}
									${index === 0 ? 'sm:rounded-l-full' : ''}
									${index === array.length - 1 ? 'sm:rounded-r-full' : ''}
									${index === 1 ? 'sm:rounded-none' : ''}
									${currentGroup === group ? 'bg-[#ff7a00] text-white font-bold' : 'bg-[#DEE4E8] text-[#777777]'}`}
								>
									{group === 'salesIncentive' && 'Sales Incentives'}
									{group === 'digitalEducation' && 'Digital Education'}
									{group === 'frontlineInsights' && 'Frontline Insights'}
								</button>
							))}
						</div>
					</div>
				</div>

				<div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
					<PricingCard
						data={bannersData[currentGroup].banner1}
						cardIndex={0}
						currentGroup={currentGroup}
					/>
					<PricingCard
						data={bannersData[currentGroup].banner2}
						featured={true}
						cardIndex={1}
						currentGroup={currentGroup}
					/>
					<PricingCard
						data={bannersData[currentGroup].banner3}
						cardIndex={2}
						currentGroup={currentGroup}
					/>
				</div>
			</div>
		</div>
	);
};

export default ChooseCampaignType;
